import React from 'react';
import 'twin.macro';

interface Props {
  children: React.ReactNode;
  title: string;
  description: string;
}

export function CardLayout(props: Props) {
  const { children, title, description } = props;
  return (
    <div tw="grid grid-cols-1 gap-x-8 gap-y-8 lg:grid-cols-3">
      <div tw="bg-white shadow-sm ring-1 ring-neutral-intense/5 sm:rounded-xl lg:col-span-2">
        <div tw="px-4 py-6 sm:p-8">
          <div tw="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 md:gap-y-6 sm:grid-cols-6">
            {children}
          </div>
        </div>
      </div>
      <div tw="px-4 sm:px-0 order-first lg:order-last">
        <h2 tw="text-base font-semibold leading-7 text-neutral-intense">
          {title}
        </h2>
        <p tw="mt-1 text-sm leading-6 text-neutral-quiet">{description}</p>
      </div>
    </div>
  );
}
